module.exports = __webpack_public_path__ + "static/media/control-mission.acf635be.gif";